import type { OptimizerServiceManagerReturn } from '@/optimizer/createOptimizerServiceManager';
import { withOptimizerTimeout } from '@/optimizer/helpers/withOptimizerTimeout';
import type { Message } from '@analytical-alley/opt-wasm';
import type { OptimisationInputs } from './optimisationSession';

export const lockedVariables = (inputs: OptimisationInputs): Record<string, number> =>
    Object.fromEntries(
        Object.entries(inputs.channels)
            .filter(([, channel]) => channel.locked && channel.investment != null)
            .map(([name, channel]) => [name, Number(channel.investment)]),
    );

export const readOptimizerMessages = async (
    optimizer: Pick<OptimizerServiceManagerReturn, 'messages'>,
): Promise<Message[]> => {
    try {
        return await withOptimizerTimeout(optimizer.messages(), 'Optimizer messages lookup');
    } catch {
        return [];
    }
};
